import {Base,Axios} from "@/api/Base"

export class SalaryDownload extends Base {

    path = "salary/download"
    download(param = {}) {
        return Axios.get(this.path, { params: param,responseType: "blob" })
    }
}